import { DialogContent, Stack, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import {
  selectSelectedPrompt,
  selectSelectedPromptGroup_deprecated,
} from '../../../../reducers/promptLibraryReducer';
import { useSelector } from 'react-redux';
import { CloseButton } from './CloseButton';
import { Button } from '@sweep-io/sweep-design';
import { SinglePromptEditMode } from '../singlePromptDialog/SinglePromptEditMode';
import { usePrompt } from '../../promptsLibrary/usePrompt';
import { usePromptGroups } from '../../promptsLibrary/usePromptGroups';
import { useState, useEffect, createElement } from 'react';
import { Prompt } from '@server/prompts';
import isEqual from 'lodash/isEqual';
import useConfirm from '../../../common/dialogs/ConfirmLeaveWithoutSave/useConfirm';
import { ConfirmLeaveWithoutSaveDialog } from '../../../common/dialogs/ConfirmLeaveWithoutSave/ConfirmLeaveWithoutSaveDialog';

export const EditPromptView = () => {
  const selectedPromptGroup = useSelector(selectSelectedPromptGroup_deprecated);
  const selectedPrompt = useSelector(selectSelectedPrompt);
  const [promptInEdit, setPromptInEdit] = useState<Prompt | null>(selectedPrompt);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { unselectPrompt, createPrompt_deprecated, updatePrompt_deprecated, removeEmptyPrompt } =
    usePrompt();
  const { openConfirm } = useConfirm();
  const { unSelectGroup } = usePromptGroups();
  const isPristine = isEqual(selectedPrompt, promptInEdit);
  const isValid = promptInEdit?.name && promptInEdit?.promptText;

  const onSave = async () => {
    setIsSubmitting(true);
    if (promptInEdit?.id === '') {
      await createPrompt_deprecated(selectedPromptGroup?.id ?? '', promptInEdit);
    } else if (promptInEdit) {
      await updatePrompt_deprecated(
        selectedPromptGroup?.id ?? '',
        promptInEdit?.id ?? '',
        promptInEdit,
      );
    }
    setIsSubmitting(false);
    unselectPrompt();
  };

  const onClose = async () => {
    if (!isPristine) {
      const isConfirmed = await openConfirm(createElement(ConfirmLeaveWithoutSaveDialog));
      if (!isConfirmed) return;
    }

    removeEmptyPrompt(selectedPromptGroup?.id ?? '');

    if (!selectedPromptGroup?.prompts?.length || selectedPromptGroup?.prompts?.length === 1) {
      unSelectGroup();
      return;
    }

    unselectPrompt();
  };

  useEffect(() => {
    if (selectedPrompt && !promptInEdit) {
      setPromptInEdit(selectedPrompt);
    }
  }, [promptInEdit, selectedPrompt]);

  if (!promptInEdit) return null;

  return (
    <>
      <DialogTitle
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 4, pb: 0 }}
      >
        <Typography variant="h1">
          {selectedPrompt?.id === '' ? 'Create new prompt' : 'Update prompt'}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            disabled={isPristine || !isValid || isSubmitting}
            onClick={onSave}
            loading={isSubmitting}
          >
            Save
          </Button>

          <CloseButton onClose={onClose} />
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ mt: 2, p: 4, pb: 0, pt: 0 }}>
        <SinglePromptEditMode promptInEdit={promptInEdit} setPromptInEdit={setPromptInEdit} />
      </DialogContent>
    </>
  );
};
